module.exports = __webpack_public_path__ + "static/CustomerTwo-a156a3f83dbc4ac077cded990b8ff1ec.jpeg";